import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth, API } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/map");
      return;
    }
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((r) => {
        setUser(r.data);
        // clear hash
        window.history.replaceState({}, "", "/map");
        navigate("/map", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        setError("Login failed");
        setTimeout(() => navigate("/map", { replace: true }), 1500);
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090b] text-white">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="animate-spin text-[#c2a061]" size={26} />
        <p className="font-mono-data text-xs uppercase tracking-widest text-white/60">
          {error || "Signing you in…"}
        </p>
      </div>
    </div>
  );
}
